import RolesDataTable from "../../../components/dataTable/tables/RolesDataTable";

function RolesPageView() {
  return <RolesDataTable />;
}

export default RolesPageView;
